// @noflow
import './calendar.component.css';
import 'velocity-animate/velocity.ui';

import React, { Component } from 'react';
import { velocityHelpers, VelocityTransitionGroup } from 'velocity-react';

import CalendarMonth from './month/calendar-month.component';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

const SlideRight = {
    // Register these with UI Pack so that we can use stagger later.
    In: velocityHelpers.registerEffect({
        calls: [[{ translateX: ['0%', '120%'] }, 1, { easing: 'ease-out' }]]
    }),

    Out: velocityHelpers.registerEffect({
        calls: [[{ translateX: ['-120%', '0%'] }, 1, { easing: 'ease-out' }]]
    })
};

const SlideLeft = {
    // Register these with UI Pack so that we can use stagger later.
    In: velocityHelpers.registerEffect({
        calls: [[{ translateX: ['0%', '-120%'] }, 1, { easing: 'ease-out' }]]
    }),

    Out: velocityHelpers.registerEffect({
        calls: [[{ translateX: ['120%', '0%'] }, 1, { easing: 'ease-out' }]]
    })
};

export default class Calendar extends Component {
    static propTypes = {
        displaySingleActive: PropTypes.bool,
        endDate: PropTypes.instanceOf(Date),
        handleDateSelected: PropTypes.func.isRequired,
        startDate: PropTypes.instanceOf(Date)
    };

    constructor(props, context) {
        super(props, context);

        const { startDate } = this.props;
        const dateToRender = startDate || new Date();

        this.state = {
            dateToRender: dateToRender,
            items: [`month-${dateToRender.getMonth()}`],
            slideDirection: 'none'
        };
    }

    handleMonthSelected(d) {
        const slideDirection = this.getSlideDirection(this.state.dateToRender.getMonth(), d.getMonth());

        this.setState({
            dateToRender: d,
            items: [`month-${d.getMonth()}`],
            slideDirection: slideDirection
        });
    }

    getSlideDirection(current, next) {
        let slideDirection = 'none';

        if (next === 11 && current === 0) {
            slideDirection = 'left';
        } else if (next === 0 && current === 11) {
            slideDirection = 'right';
        } else if (next < current) {
            slideDirection = 'left';
        } else if (next > current) {
            slideDirection = 'right';
        }

        return slideDirection;
    }

    showPrevious = () => {
        const { dateToRender } = this.state;
        this.handleMonthSelected(
            moment(dateToRender)
                .subtract(1, 'month')
                .toDate()
        );
    };

    showNext = () => {
        const { dateToRender } = this.state;
        this.handleMonthSelected(
            moment(dateToRender)
                .add(1, 'month')
                .toDate()
        );
    };

    render() {
        const { startDate, endDate, displaySingleActive, handleDateSelected } = this.props;
        const { dateToRender, slideDirection } = this.state;

        const monthId = parseInt(dateToRender.getMonth(), 10);

        return (
            <div className="calendar">
                <div className="calendar__month-blocker-left" />
                <div className="calendar__month-blocker-right" />
                <button className="calendar__left-click" data-qa="calendar-left" onClick={this.showPrevious}>
                    <span className="general-icon__left" />
                </button>
                <button className="calendar__right-click" data-qa="calendar-right" onClick={this.showNext}>
                    <span className="general-icon__right" />
                </button>
                <VelocityTransitionGroup
                    className="calendar__container"
                    component="div"
                    enter={{
                        animation: (slideDirection === 'left' ? SlideLeft : SlideRight).In,
                        duration: 500
                    }}
                    leave={{
                        animation: (slideDirection === 'left' ? SlideLeft : SlideRight).Out,
                        duration: 500
                    }}
                >
                    <CalendarMonth
                        className="calendar__month"
                        dateToRender={dateToRender}
                        displaySingleActive={displaySingleActive}
                        endDate={endDate}
                        fixedMonth={monthId}
                        handleDateSelected={handleDateSelected}
                        key={`month-${monthId}`}
                        startDate={startDate}
                    />
                </VelocityTransitionGroup>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/calendar/calendar.component.js